export default interface Jwt {
  sub: string;
  companyId: string;
  roles: JwtRole[];
  companyName: string;
  language: string;
  email: string;
  isDashboardEnabled: boolean;
  solution: AccountSolution;
}

export interface JwtRole {
  authority: UserRole;
}

/**
 * Energy Monitoring - Buildings and EV charging stations
 * Smart Water Metering - Leak detection and control
 * Pressure Monitoring for NRW water loss redictuon
 * Gas Monitoring - for enterprises and utilities
 * Level Monitoring - for dams and tanks
 */

export enum AccountSolution {
  NONE = 'NONE',
  AGRI = 'AGRI',
  STREET_LIGHTS = 'STREET_LIGHTS',
  AIR_QUALITY = 'AIR_QUALITY',
  PUMP_STATION = 'PUMP_STATION',
  SMART_WASTE = 'SMART_WASTE',
  LEVEL = 'LEVEL',
  GAS = 'GAS',
  PRESSURE = 'PRESSURE',
  SMART_WATER = 'SMART_WATER',
  ENERGY = 'ENERGY',
  ENVIRONMENT_MONITORING = 'ENVIRONMENT_MONITORING',
}

export type UserRole =
  | 'ROLE_USER'
  | 'ROLE_ADMIN'
  | 'ROLE_RESTRICTED'
  | 'ROLE_SUPER_ADMIN'
  | 'ROLE_AGRICULTURE'
  | 'ROLE_METER_READER'
  | 'ROLE_BILLING'
  | 'ROLE_PUBLIC';
